"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodePath = encodePath;
exports.basename = basename;
exports.dirname = dirname;
exports.joinPaths = joinPaths;
exports.isSamePath = isSamePath;

/**
 * URI-Encodes a file path but keep the path slashes.
 */
function encodePath(path) {
  if (!path) {
    return path;
  }

  return path.split('/').map(encodeURIComponent).join('/');
}
/**
 * Returns the base name of the given path.
 * For example for "/abc/somefile.txt" it will return "somefile.txt"
 */


function basename(path) {
  return path.replace(/\\/g, '/').replace(/.*\//, '');
}
/**
 * Returns the dir name of the given path.
 * For example for "/abc/somefile.txt" it will return "/abc"
 */


function dirname(path) {
  return path.replace(/\\/g, '/').replace(/\/[^\/]*$/, '');
}
/**
 * Join path sections
 */


function joinPaths() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (arguments.length < 1) {
    return '';
  } // discard empty arguments


  var nonEmptyArgs = args.filter(function (arg) {
    return arg.length > 0;
  });

  if (nonEmptyArgs.length < 1) {
    return '';
  }

  var lastArg = nonEmptyArgs[nonEmptyArgs.length - 1];
  var leadingSlash = nonEmptyArgs[0].charAt(0) === '/';
  var trailingSlash = lastArg.charAt(lastArg.length - 1) === '/';
  var sections = nonEmptyArgs.reduce(function (acc, section) {
    return acc.concat(section.split('/'));
  }, []);
  var first = !leadingSlash;
  var path = sections.reduce(function (acc, section) {
    if (section === '') {
      return acc;
    }

    if (first) {
      first = false;
      return acc + section;
    }

    return acc + '/' + section;
  }, '');

  if (trailingSlash) {
    // add it back
    return path + '/';
  }

  return path;
}
/**
 * Returns whether the given paths are the same, without
 * leading, trailing or doubled slashes and also removing
 * the dot sections.
 */


function isSamePath(path1, path2) {
  var pathSections1 = (path1 || '').split('/').filter(function (p) {
    return p !== '.';
  });
  var pathSections2 = (path2 || '').split('/').filter(function (p) {
    return p !== '.';
  });
  path1 = joinPaths.apply(undefined, pathSections1);
  path2 = joinPaths.apply(undefined, pathSections2);
  return path1 === path2;
}
//# sourceMappingURL=index.js.map